export default {
  email: 'Podaj e-mail',
  user: 'E-mail',
  password: 'Hasło',
  old_password: 'Stare hasło',
  new_password: 'Nowe hasło',
  new_password_confirmation: 'Potwierdź nowe hasło',
  new_password_error: 'Wystąpił błąd. Spróbuj ponownie.',
  forgot: 'Nie pamiętam hasła',
  forgot_label: '* Jeśli nie aktywowałeś jeszcze swojego konta skorzystaj z opcji:',
  reset_password: 'Zresetuj hasło',
  reset: 'Resetuj',
  reset_password_invalid: 'Link do resetowania hasła jest nieaktywny.',
  reset_password_invalid_token_title: 'Aby wygenerować nowy link,',
  reset_password_invalid_token_content: 'i kliknij „Nie pamiętam hasła”.',
  reset_password_invalid_token_button: 'przejdź do strony logowania',
  new_password_request_email: 'Wprowadź e-mail',
  new_password_request_heading: 'Drogi rodzicu!',
  new_password_request_text_1: 'W związku ze zmianą podmiotu odpowiedzialnego za administrowanie ES Online oraz danymi osób, którzy z ES Online korzystają, wymagana jest ponowna rejestracja w ES Online.<br>Musimy poprosić Cię o aktywację konta.',
  new_password_request_text_2: 'Po naciśnięciu przycisku “wyślij”, \nna poniższy adres email prześlemy Ci wiadomość z linkiem aktywacyjnym.',
  new_password_request_footer: 'Nie jesteś klientem Early Stage?',
  new_password_request_success_heading: 'Wysłaliśmy Ci wiadomość',
  new_password_request_success_info: 'Sprawdź skrzynkę pocztową,<br> znajdziesz tam instrukcje w jaki sposób odzyskać dostęp<br> do świata Early Stage',
  change_password: 'Zmień hasło',
  save_password: 'Zapisz hasło',
  save_data: 'Zapisz dane',
  edit_data: 'Edytuj dane',
  remember: 'Zapamiętaj mnie',
  no_account: 'Nie jesteś klientem Early Stage?',
  register: 'Zapisz się!',
  login: 'Zaloguj się',
  send: 'Wyślij',
  save: 'Zapisz',
  connectionError: 'Brak połączenia internetowego',
  hasAccountError: 'Sprawdź wpisane dane. Pamiętaj też, że co roku tworzymy nowe konto dla Twojego dziecka. Odszukaj w swojej skrzynce maila z linkiem do aktywacji konta.',
  loginError: 'Niepoprawny login lub hasło',
  settings: 'Ustawienia',
  logout: 'Wyloguj się',
  new_password_requested: 'Na podany adres wysłano wiadomość z dalszymi instrukcjami.',
  new_password_request_failed: 'Podany adres email nie istnieje!',
  invalid_token_title: 'Link do pierwszego logowania nie jest aktywny.',
  invalid_token_title_2: 'Link do ustawienia hasła nie jest już aktywny.',
  invalid_token_content: 'Jeżeli masz już ustawione hasło, ',
  invalid_token_button: 'przejdź do strony logowania',
  invalid_token: 'Jeżeli nie - skontaktuj się z Twoją filią Early Stage.',
  token_expired: 'Token wygasł. Zaloguj się ponownie.',
  unauthorized: 'Zaloguj się, aby przejść dalej!',
  first_login: 'Stwórz hasło',
  first_login_password: 'Wprowadź hasło',
  first_login_password_confirm: 'Powtórz hasło',
  first_login_text: 'Za pomocą tego hasła będziesz się logować do ES Online. Loginem będzie Twój adres e-mail.',
  start_login: 'Zaloguj się',
  start_world: 'do świata Early Stage',
  tip: 'Pamiętaj! Hasło musi zawierać przynajmniej jedną cyfrę.',
  successful: 'Hasło zostało zmienione',
  refunds_name_input: 'Imię i nazwisko odbiorcy',
  refunds_bank_input: 'Numer konta bankowego',
  refunds_additional_children_label: 'Zapisz dane również dla innych dzieci',
  refunds_select_additional_children: 'Wybierz dzieci, dla których chcesz zapisać dane:',
  refunds_data_name_label: 'Odbiorca przelewu',
  refunds_data_bank_label: 'Numer konta bankowego',
  refunds_data_saved_for: 'Zapisano dane dla',
  refunds_data_error_general: 'Wystąpił błąd',
};
